module.exports = __webpack_public_path__ + "img/charms.a62523f5.jpg";